import React from "react";

export function BurnQuote({ quote, err, loading }) {
  if (loading) return <div className="text-sm text-slate-400" data-testid="burn-quote-loading">Getting live price…</div>;
  if (err) return <div className="text-sm text-rose-400" data-testid="burn-quote-error">{err}</div>;
  if (!quote) return null;
  if (!quote.accepted) return <div className="text-sm text-amber-400" data-testid="burn-quote-rejected">{quote.reason}</div>;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm" data-testid="burn-quote">
      <div><div className="text-slate-500 text-xs">Value</div><div className="font-mono" data-testid="burn-quote-usd">${quote.usd_value.toLocaleString()}</div></div>
      <div><div className="text-slate-500 text-xs">Coin size</div><div data-testid="burn-quote-tier">{quote.tier}</div></div>
      <div><div className="text-slate-500 text-xs">Bonus</div><div className="text-emerald-400 font-mono" data-testid="burn-quote-mult">{quote.multiplier}x</div></div>
      <div><div className="text-slate-500 text-xs">You earn</div><div className="text-cyan-300 font-mono font-bold" data-testid="burn-quote-credits">{quote.credits.toLocaleString()} credits</div></div>
    </div>
  );
}
